/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Describes the customer/company and all the metadata we keep
 */
export interface Customer {
  /**
   * The customer/company name
   */
  customer_name?: string;
  /**
   * A URL that contains the logo related with this customer
   */
  customer_logo?: string;

  /**
   * whether the customer has onboarded or not
   */
  is_onboarded?: boolean;

  /**
   * list of features the customer can access
   */
  account_features?: AccountFeatureEnum[];

  /**
   * The Account type of the customer
   */
  account_type?: AccountTypeEnum | string;

  account_config?: {
    framework_limit?: number;
    risk_manager_risks_limit?: number;
    open_ai?: boolean;
    automated_gap_enabled?: boolean;
  };
}

export type AccountFeatureEnum =
  | 'SCIM support'
  | 'Adopt framework'
  | 'Audit zone'
  | 'Run on demand'
  | 'Reports'
  | 'Policy Templates'
  | 'Export controls'
  | 'Looker Dashboard'
  | 'Auditor Export'
  | 'User Access Review'
  | 'Employee List'
  | 'Tasks and Reviews'
  | 'Custom roles'
  | 'Iceberg Evidence'
  | 'Not Data Engine'
  | 'AI Consent';

export const AccountFeatureEnum = {
  ScimSupport: 'SCIM support' as AccountFeatureEnum,
  AdoptFramework: 'Adopt framework' as AccountFeatureEnum,
  AuditZone: 'Audit zone' as AccountFeatureEnum,
  RunOnDemand: 'Run on demand' as AccountFeatureEnum,
  Reports: 'Reports' as AccountFeatureEnum,
  PolicyTemplates: 'Policy Templates' as AccountFeatureEnum,
  ExportControls: 'Export controls' as AccountFeatureEnum,
  LookerDashboard: 'Looker Dashboard' as AccountFeatureEnum,
  AuditorExport: 'Auditor Export' as AccountFeatureEnum,
  UserAccessReview: 'User Access Review' as AccountFeatureEnum,
  EmployeeList: 'Employee List' as AccountFeatureEnum,
  AuditLogs: 'Audit Logs' as AccountFeatureEnum,
  TasksAndReviews: 'Tasks and Reviews' as AccountFeatureEnum,
  CustomRoles: 'Custom roles' as AccountFeatureEnum,
  NotDataEngine: 'Not Data Engine' as AccountFeatureEnum,
  AIConsent: 'AI Consent' as AccountFeatureEnum,
};

export type AccountTypeEnum =
  | 'Enterprise'
  | 'Coalfire'
  | 'Hyper-Growth'
  | 'Scale-Up'
  | 'Internal'
  | 'Internal-Test'
  | 'Free trial'
  | 'Pro delegated customer'
  | 'Pro customer'
  | 'Data Engine';

export const AccountTypeEnum = {
  Enterprise: 'Enterprise' as AccountTypeEnum,
  Coalfire: 'Coalfire' as AccountTypeEnum,
  HyperGrowth: 'Hyper-Growth' as AccountTypeEnum,
  ScaleUp: 'Scale-Up' as AccountTypeEnum,
  Internal: 'Internal' as AccountTypeEnum,
  InternalTest: 'Internal-Test' as AccountTypeEnum,
  FreeTrial: 'Free trial' as AccountTypeEnum,
  ProDelegatedCustomer: 'Pro delegated customer' as AccountTypeEnum,
  ProCustomer: 'Pro customer' as AccountTypeEnum,
  DataEngine: 'Data Engine' as AccountTypeEnum,
};

export enum FeatureIdEnum {
  Users = 'feature-user-grc-owner',
  SCIM = 'feature-scim',
  UAR = 'feature-uar-entities',
  UAM = 'feature-uam-app',
  RISK = 'feature-risks-entities',
  CUSTOM_ROLES = 'feature-customRoles',
  POLICY_AI = 'feature-policy-guardian',
  CONTROL_AI_ASSISTANT = 'feature-control-ai-assistant',
}
